module.exports = __webpack_public_path__ + "static/media/tapingo_logo2@2x.c5cfaa39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tapingo_logo2@2x.png
// module id = 272
// module chunks = 0